import { AnyAction } from 'redux';
import { findReimbursement } from '~/Api/Analytics/VirtualBrand/Reimbursement';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectReimbursementById } from './reducer';

export function fetchReimbursement(id: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findReimbursement, id));
		dispatch({ type: ActionTypes.request, request, id });

		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionTypes.receive,
				request,
				id,
				items: response?.items,
			});
			if (error) {
				dispatch(handleError(error));
			}
		});
	};
}

export function loadReimbursement(id: string): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		await (selectReimbursementById(getState().medicinalBrandsAnalyticsReimbursement, id)?.request ||
			dispatch(fetchReimbursement(id)));
	};
}

export function pruneAll(): AnyAction {
	return { type: ActionTypes.pruneAll };
}
